import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function DSCRLoanPage() {
  return (
    <LoanProgramTemplate
      title="DSCR Program"
      subtitle="Alternative Options"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907303/DSCR_vxzoqu.png"
      descriptionBold="DSCR loans (Debt Service Coverage Ratio)"
      description="qualify borrowers based on the income produced by an investment property rather than personal income. They are ideal for investors who want the property's cash flow to support the loan."
      whyBuyersConsider="DSCR loans allow investors to qualify based on rental income rather than personal income, offering a streamlined way to expand or begin building a real estate portfolio."
      eligibilityItems={[
        'Show that the property’s rent covers the monthly payment',
        'Provide a qualifying credit score and required reserves',
        'Bring the minimum down payment needed for the loan',
      ]}
      benefitsItems={[
        'Loan amounts up to max $2M',
        'Cash out up to $1.5M',
        'FICO as low as 660',
        'No income documents required',
      ]}
    />
  );
}
